import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt } from '@fortawesome/pro-solid-svg-icons';

// actions
import { placeCall } from '../../../../actions/telephony';

function RedialButton({ className }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    values: { shopper_phone: shopperPhone },
    form: { baseRoute },
  } = useSelector(store => store);

  const re = /^[0-9]{10}$/g;
  const isValidPhone = re.test(shopperPhone);

  useEffect(() => {
    if (isValidPhone) {
      const error = '';
      dispatch({ type: 'SET_CALL_ERROR', error });
    } else {
      const error = (
        <span>
          You must
          <u
            role="button"
            tabIndex={0}
            className="mx-1 fw-bold"
            onClick={() => navigate(`/enroll${baseRoute}/telephony/call?focusPhone=true`)}
          >
            enter a number
          </u>
          to redial
        </span>
      );
      dispatch({ type: 'SET_CALL_ERROR', error });
    }
  }, [shopperPhone]);

  return (
    <button
      type="button"
      className={['btn btn-warning', className].join(' ')}
      onClick={() => placeCall(shopperPhone)}
      disabled={!isValidPhone}
    >
      Redial
      <FontAwesomeIcon className="ms-2" icon={faPhoneAlt} />
    </button>
  );
}

export default RedialButton;
